import { useUser } from "@faire/retailer-visitor-shared/hooks/user/useUser";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";

export const useUserType = () => {
  const { user } = useUser();
  const isBrandUser = user?.type === IUser.Type.BRAND_USER;
  const isAdminUser = user?.type === IUser.Type.ADMIN;
  const isImpersonating = !!user?.impersonating;
  const isEmployee = !!user?.is_employee;
  const hasFaireEmailAddress = !!user?.email_address?.endsWith("@faire.com");

  return {
    isBrandUser,
    isAdminUser,
    isImpersonating,
    isEmployee,
    hasFaireEmailAddress,
  };
};
